<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6Oj5XX/tc-custom/9781429906180.jpg?1745277964680" alt="This image is the cover for the book Dirty Little Secrets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dirty Little Secrets
      </h1>
      <p class="bookDescription body article font2">
        <br/><br/><b>In this “absorbing” novel, a southern woman takes on NYC and a shot at stardom while struggling to find lasting love (<i>Booklist</i>).</b><br/><br/>Nothing prepares Tyler Blake for the fast-paced living of New York City. A small-town girl from Georgia, she quickly gets caught up in the glamorous entertainment industry. While pursuing her dream of becoming an actress, Tyler continually gets sidetracked by men who promise to help her and finds herself going from one dysfunctional relationship to another.<br/><br/>Just when Tyler finally believes she has found her ideal man in hip-hop producer Brian McCall, everything begins to go horribly wrong. Trapped in a nightmarish relationship, Tyler is determined not to go down without a fight.<br/><br/>“Passion, deception, heartbreak, love and a delicious read . . . what more do you need!” — B. Lawson Thornton, Essence–bestselling author of <i>Misery Loves Company</i><br/><br/>“A riveting, sexy tale.” —Trista Russell, bestselling author of <i>Going Broke</i> and <i>Fly on the Wall</i><br/><br/>“A true roller-coaster ride for the heart and mind. . . . Honest and real.” —Maryann Reid, author of <i>Marry Your Baby Daddy</i> and <i>Use Me or Lose Me</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joy King
      </h2>
      
      <p class="authorDescription body article">Nationally bestselling author Joy Deja King, also known as the Literary Sweetheart, has written young, hip and sexy novels that introduce readers to street life in all its complexity and to the glamorous yet toxic entertainment industry. With over fifty novels under her belt, she was the #1 <I>Essence</I> bestselling author seven months straight for her title <I>Queen Bitch</I>, from her hugely popular Bitch Series, and in 2019 won the African American Literary Award for Best Street/Urban Fiction for <I>Assassins...: Episode 1 (Be Careful With Me)</I>. Joy has solidified herself as a mainstay in the urban street fiction genre. She made her literary debut with the release of her first novel, <I>Dirty Little Secrets</I> (under St. Martin’s Press), and followed it up with the sequel <I>Hooker to Housewife</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a7dc8360